import { render, staticRenderFns } from "./dataDonut.vue?vue&type=template&id=244ac71e&"
import script from "./dataDonut.vue?vue&type=script&lang=ts&"
export * from "./dataDonut.vue?vue&type=script&lang=ts&"
import style0 from "./dataDonut.vue?vue&type=style&index=0&id=244ac71e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports